module.exports = __webpack_public_path__ + "img/leaves-front-2x.bd3a369f.png";